import { render, staticRenderFns } from "./opendialog.vue?vue&type=template&id=703b1135&"
import script from "./opendialog.vue?vue&type=script&lang=js&"
export * from "./opendialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703b1135')) {
      api.createRecord('703b1135', component.options)
    } else {
      api.reload('703b1135', component.options)
    }
    module.hot.accept("./opendialog.vue?vue&type=template&id=703b1135&", function () {
      api.rerender('703b1135', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/opendialog.vue"
export default component.exports